import React, { useContext } from "react";
import { Label } from "structure/Document";
import SocialReason from "components/general/Forms/Selects/SocialReason";
import { ContextContract } from "structure/Contract/List";

export default function SocialReasonSelect() {
  const { socialReason, updateSocialReason } = useContext(ContextContract);

  return (
    <div>
      <Label>Razon social</Label>
      <SocialReason
        aditionalOptions={[
          {
            id: null,
            isActive: true,
            label: "Todos",
            socialReason: "Todos",
            value: null,
            
          },
        ]}
        isClearable={true}
        includeNoActives={false}
        type="cliente"
        onChange={({ id , socialReason }) => updateSocialReason(id,socialReason)}
        value={socialReason}
      />
    </div>
  );
}
